import { configureStore } from "@reduxjs/toolkit"
import { localizationReducer } from "../localization/localizationSlice"
import { contextReducer } from "../context/contextSlice"
import { configReducer } from "../config/configSlice"
import { loginReducer } from "../login/loginSlice"
import { userReducer } from "../users/userSlice"
import { errorReducer } from "../../shared/components/errors/store/errorSlice"
import { nonAdminUserReducer } from "../nonAdminUser/nonAdminUserSlice"
import { serviceCenterReducer } from "../serviceCenter/store/serviceCenterSlice"

export const store = configureStore({
    reducer: {
        login: loginReducer,
        user: userReducer,
        localization: localizationReducer,
        context: contextReducer,
        config: configReducer,
        nonAdminUser: nonAdminUserReducer,
        serviceCenter: serviceCenterReducer,
        error: errorReducer,
    },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
